import React, { useEffect } from 'react'
import { TextField, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Checkbox, MenuItem, Box, Tabs, Tab, InputLabel, Select, Button, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from "@mui/material";
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import axios from 'axios';
import { BURL } from '../../../services/base';
import { formatDate, formatDateTime, shortenText } from '../../../utils/common.utils';
import useAPI from '../../../hooks/useAPI';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useFormik } from 'formik';
import SmallLoader from '../../widgets/SmallLoader';
import { invoiceValidationSchema, paymentValidationSchema } from '../../../schemas/validation.schema';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const TenantDetails = () => {
    const [profileImage, setProfileImage] = React.useState("/profile-avatar.png");
    const [base64Image, setBase64Image] = React.useState(""); // Base64 string to send to server
    const [tenantDetails, setTenantDetails] = React.useState();
    const [tenantRoomDetails, setTenantRoomDetails] = React.useState();
    const [paymentHistory, setPaymentHistory] = React.useState([]);
    const [selectedRoom, setSelectedRoom] = React.useState();
    const [formData, setFormData] = React.useState({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        gender: "Female",
        age: "",
        occupation: "",
        workplace: "",
        policeCustody: false,
        felony: false,
        emergencyContactName: "",
        emergencyContactPhone: "",
        emergencyContactRelation: "",
    });
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [tenantCurrentRoomId, setTenantCurrentRoomId] = React.useState();
    const [tenantFullName, setTenantFullName] = React.useState('');
    const [invoiceItems, setInvoiceItems] = React.useState([]);
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [confirmationOpen, setConfirmationOpen] = React.useState(false);
    const [paymentId, setPaymentId] = React.useState('');
    const [showToaster, setShowToaster] = React.useState(false);
    const [toasterType, setToasterType] = React.useState('');
    const [message, setMessage] = React.useState('');
    const [editableIndex, setEditableIndex] = React.useState(null);
    const [isInvoiceEditable, setIsInvoiceEditable] = React.useState(false);
    const [removedInvoiceDetailIds, setRemovedInvoiceDetailIds] = React.useState([]);
    const [value, setValue] = React.useState(0);
    const { tenantId } = useParams();
    const [paymentOpen, setPaymentOpen] = React.useState(false);
    const paymentTypes = [
        "cash",
        "teller",
        "transfer",
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const { POST, GET, DELETEREQ } = useAPI();

    const formik = useFormik({
        initialValues: {
            amount: '',
            ref: '',
            type: ''
        },
        validationSchema: paymentValidationSchema,
        onSubmit: (values, { resetForm }) => {
            setConfirmLoading(true);
            handleAddPayment(resetForm);
        }
    });

    const formik2 = useFormik({
        initialValues: {
            title: '',
            description: '',
            amount: ''
        },
        validationSchema: invoiceValidationSchema,
        onSubmit: (values, { resetForm }) => {
            setInvoiceItems(e => [...(Array.isArray(e) ? e : []), values]);
            resetForm();
        }
    });

    const handleClose = () => {
        setPaymentOpen(false);
    };

    const handleToasterClose = () => {
        setShowToaster(false);
    };

    const handleConfirmation = (paymentId) => {
        setConfirmationOpen(true);
        setPaymentId(paymentId)
    };

    // Handle File Upload
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setProfileImage(reader.result);
                setBase64Image(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // Handle room Change
    const handleRoomChange = (e) => {
        const roomId = e.target.value;
        const index = tenantDetails.tenancyHistory.findIndex(
            (room) => room.tenantRoomId === roomId
        );

        const selectedRoomObj = tenantDetails.tenancyHistory[index];
        const updatedRoom = {
            ...selectedRoomObj,
            fullName: `${tenantDetails?.user?.firstname} ${''} ${tenantDetails?.user?.lastname}`,
            active: selectedRoomObj.active ? 'active' : 'inactive',
            checkIn: formatDateTime(selectedRoomObj.checkIn),
            checkOut: formatDateTime(selectedRoomObj.checkOut),
        }
        // setSelectedRoom(updatedRoom);
        // setTenantCurrentRoomId(roomId);
        // if (tenantCurrentRoomId !== roomId) {
        //     fetchTenantRoomByTenantRoomId(tenantCurrentRoomId);
        // }
        setSelectedRoom(updatedRoom);

        setTenantCurrentRoomId(roomId);

        fetchTenantRoomByTenantRoomId(roomId);
    };

    const fetchTenantDetails = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(`${BURL}/admin/tenants/${tenantId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const tenant_details = await response.data.data;
            setTenantDetails(tenant_details);
            const tenancyHistoryIndexZero = await tenant_details.tenancyHistory[0];
            const updatedRoom = {
                ...tenancyHistoryIndexZero,
                fullName: `${tenant_details?.user?.firstname} ${''} ${tenant_details?.user?.lastname}`,
                active: tenancyHistoryIndexZero.active ? 'active' : 'inactive',
                checkIn: formatDateTime(tenancyHistoryIndexZero.checkIn),
                checkOut: formatDateTime(tenancyHistoryIndexZero.checkOut),
            }
            setSelectedRoom(updatedRoom);
            setTenantCurrentRoomId(tenant_details.tenancyHistory[0].tenantRoomId);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchTenantRoomByTenantRoomId = async (tenantRoomId) => {
        const token = localStorage.getItem('token');
        if (tenantRoomId !== undefined) {
            try {
                const response = await axios.get(`${BURL}admin/tenant-rooms/${tenantRoomId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });
                const tenant_room_details = await response.data.data;

                const updatedRoomDetails = {
                    ...tenant_room_details,
                    totalAmount: tenant_room_details?.invoices[0]?.totalAmount == null ? 0 : tenant_room_details?.invoices[0]?.totalAmount,
                    totalPaid: tenant_room_details?.invoices[0]?.totalPaid == null ? 0 : tenant_room_details?.invoices[0]?.totalPaid,
                    balance: tenant_room_details?.balance == null ? 0 : tenant_room_details?.balance,
                }
                setTenantRoomDetails(updatedRoomDetails);
                setInvoiceItems(tenant_room_details?.invoices[0]?.details);
                setPaymentHistory(tenant_room_details?.invoices[0]?.payments);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        } else {
            return '';
        }
    };

    const refetchTenantPage = async (roomId = tenantCurrentRoomId) => {
        if (!tenantId) return;

        await fetchTenantDetails();

        if (roomId) {
            await fetchTenantRoomByTenantRoomId(roomId);
        }
    };


    useEffect(() => {
        fetchTenantDetails();
    }, [tenantId]);

    useEffect(() => {
        if (tenantCurrentRoomId !== undefined && tenantCurrentRoomId !== null) {
            fetchTenantRoomByTenantRoomId(tenantCurrentRoomId);
        }
    }, [tenantCurrentRoomId]);

    const handleItemChange = (e, index) => {
        const { name, value } = e.target;
        const updatedItems = [...invoiceItems];
        updatedItems[index] = { ...updatedItems[index], [name]: value };
        setInvoiceItems(updatedItems);
    };

    const handleSave = (index) => {
        setEditableIndex(null);
    }

    const handleDeleteItem = (index) => {
        const itemToRemove = invoiceItems[index];

        const newItems = [...invoiceItems];
        newItems.splice(index, 1);
        setInvoiceItems(newItems);
        if (itemToRemove?.id && !removedInvoiceDetailIds.includes(itemToRemove.id)) {
            setRemovedInvoiceDetailIds(prev => [...prev, itemToRemove.id]);
        }
    };

    const handleDeleteInvoiceItemFromDB = async () => {
        const url = 'admin/invoice-items';
        const token = localStorage.getItem('token');
        const body = { invoiceDetailIds: removedInvoiceDetailIds };

        const response = await DELETEREQ(url, body, token);

        if (!response?.status) {
            throw new Error(response?.message ?? 'Failed to delete invoice items');
        }
        return await response.data;
    };

    const handleUpdateInvoice = async () => {
        setConfirmLoading(true);
        try {
            // Delete items first (if any)
            if (removedInvoiceDetailIds.length > 0) {
                await handleDeleteInvoiceItemFromDB();
                setRemovedInvoiceDetailIds([]);
            }
            // Save new items
            // Prepare new items (exclude ones with IDs)
            const newItems = invoiceItems.filter(item => !item.id);

            if (newItems.length > 0) {
                const url = 'admin/invoice-items';
                const token = localStorage.getItem('token');
                const body = {
                    propertyId: selectedRoom?.room?.unit?.property?.id,
                    invoiceId: tenantRoomDetails.invoices[0]?.id,
                    details: newItems
                };

                const response = await POST(url, body, token);

                if (response?.status) {
                    const res = await response.data;
                    setInvoiceItems([]);
                    setShowToaster(true);
                    setToasterType('success');
                    setMessage(res.message || 'Invoice updated successfully');
                    // fetchTenantRoomByTenantRoomId(tenantCurrentRoomId);
                    await refetchTenantPage();
                    setIsInvoiceEditable(false);
                } else {
                    setShowToaster(true);
                    setToasterType('error');
                    setMessage(response.message ?? 'An error occurred while adding invoice items, try again please.');
                    setConfirmLoading(false);
                }
            }
        } catch (err) {
            setShowToaster(true);
            setToasterType('error');
            setMessage(`${err} Something went wrong. Please try again.`);
        } finally {
            setConfirmLoading(false);
        }
    }

    const handleAddPayment = async (resetForm) => {
        setConfirmLoading(true);
        try {
            const url = 'admin/invoice-payments';
            const token = localStorage.getItem('token');
            const body = await {
                invoiceId: tenantRoomDetails?.invoices[0]?.id,
                amount: formik.values.amount,
                type: formik.values.type,
                ref: formik.values.ref,
            };
            const response = await POST(url, body, token);

            if (response?.status) {
                const res = await response.data;
                resetForm();
                setShowToaster(true);
                setToasterType('success');
                setMessage(res.message || 'Payment Added successfully');
                setPaymentOpen(false);
                // fetchTenantRoomByTenantRoomId(tenantCurrentRoomId);
                await refetchTenantPage();
            } else {
                setShowToaster(true);
                setToasterType('error');
                setMessage(response.message ?? 'An error occurred while adding payment, try again please.');
                setConfirmLoading(false);
            }
        } catch (err) {
            setShowToaster(true);
            setToasterType('error');
            setMessage(`${err} Something went wrong. Please try again.`);
        } finally {
            setConfirmLoading(false);
        }
    }

    const handleDeletePayment = async () => {
        const token = localStorage.getItem('token');
        setConfirmLoading(true);
        try {
            const url = `admin/invoice-payments`;
            const body = { paymentId };
            const response = await DELETEREQ(url, body, token);
            if (response?.status) {
                setShowToaster(true);
                setToasterType('success');
                setMessage(response.message || 'Payment deleted successfully');
                // fetchTenantRoomByTenantRoomId(tenantCurrentRoomId);
                await refetchTenantPage();
            } else {
                setShowToaster(true);
                setToasterType('error');
                setMessage(response.message ?? 'An error occurred while deleting payment, try again please.');
            }
        } catch (err) {
            setShowToaster(true);
            setToasterType('error');
            setMessage(`${err} Something went wrong. Please try again.`);
        } finally {
            setConfirmLoading(false);
            setConfirmationOpen(false);
        }
    };

    // Tenant room(s)  
    const tenantRoomList = Array.isArray(tenantDetails?.tenancyHistory) &&
        tenantDetails.tenancyHistory.map((room, i) => {
            return (
                <MenuItem
                    key={room.tenantRoomId || i}
                    className='capitalize'
                    value={room.tenantRoomId}
                >
                    <div className='flex flex-col gap-1'>
                        {room.room?.tag ?? 'No tag'}
                        <span className='text-sm text-gray-400'>{shortenText(room?.room?.unit?.property?.name, 16)} | {room?.room?.unit?.name}</span>
                    </div>
                </MenuItem>
            );
        });
    // End of tenant room(s)  

    // Payment Type
    const typeList = Array.isArray(paymentTypes) &&
        paymentTypes.map((type, i) => {
            return (
                <MenuItem
                    key={type || i}
                    className='capitalize'
                    value={type}
                >
                    {type ?? 'No type'}
                </MenuItem>
            );
        });
    // End of payment type(s)  

    const loader = <SmallLoader />

    return (
        <React.Fragment>
            <div className="max-w-4xl min-h-screen mx-auto p-6 rounded-lg">
                <div className="flex justify-end mb-3">
                    <div className="flex-col gap-5">
                        <InputLabel id="demo-simple-select-label" className='!mb-2'>Tenent Room(s)</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name='roomId'
                            defaultValue="Tenant Room(s)"
                            className='!w-[180px] !h-[35px] !py-6 !px-2 capitalize'
                            value={tenantCurrentRoomId}
                            onChange={handleRoomChange}
                            MenuProps={{
                                style: {
                                    maxHeight: 200,
                                },
                            }}
                        >
                            {tenantRoomList}
                        </Select>
                    </div>
                </div>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', overflowX: 'auto' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className='w-[400px] md:w-full overflow-x-auto md:overflow-x-hidden'>
                            <Tab className='!hidden md:!flex' label="Personal Details" {...a11yProps(0)} />
                            <Tab className='!hidden md:!flex' label="Tenancy Details" {...a11yProps(1)} />
                            <Tab className='!hidden md:!flex' label="Payment History" {...a11yProps(2)} />
                            <Tab className='!hidden md:!flex' label="Document" {...a11yProps(3)} />
                            <Tab className='!flex md:!hidden' label="Personal" {...a11yProps(4)} />
                            <Tab className='!flex md:!hidden' label="Tenancy" {...a11yProps(5)} />
                            <Tab className='!flex md:!hidden' label="Payment" {...a11yProps(6)} />
                            <Tab className='!flex md:!hidden' label="Document" {...a11yProps(7)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0} className="py-4">
                        {/* Profile Section */}
                        <div className="flex items-center space-x-4 relative">
                            <img
                                src={profileImage}
                                alt="Profile"
                                className="w-32 h-32 md:w-44 md:h-44 rounded-full border-2 border-gray-300"
                            />
                            <label htmlFor="file-upload" className="cursor-pointer absolute top-[8.5rem] left-[7.2rem]">
                                <div className="flex items-center justify-center w-10 h-10 bg-green-600 text-white rounded-full">
                                    📸
                                </div>
                            </label>
                            <input
                                id="file-upload"
                                type="file"
                                accept="image/*"
                                className="hidden"
                                onChange={handleFileChange}
                            />
                        </div>

                        {/* Form Fields */}
                        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>First Name</label>
                                <input type="text" disabled className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' value={tenantDetails?.user?.firstname} placeholder="John" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Last Name</label>
                                <input type="text" disabled className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' value={tenantDetails?.user?.lastname} placeholder="Doe" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Phone Number</label>
                                <input type="text" disabled className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' value={tenantDetails?.user?.phone} placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Email</label>
                                <input type="text" disabled className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' value={tenantDetails?.user?.email} placeholder="example@gmail.com" />
                            </div>
                        </div>

                        {/* Gender Selection */}
                        <div className="mt-4">
                            <FormControl>
                                <FormLabel>Gender</FormLabel>
                                <RadioGroup disabled row defaultValue="Female">
                                    <FormControlLabel value="Male" control={<Radio />} label="Male" />
                                    <FormControlLabel value="Female" control={<Radio />} label="Female" />
                                </RadioGroup>
                            </FormControl>
                        </div>

                        {/* Additional Info */}
                        <div className="mt-6 bg-white p-4 rounded-lg shadow-sm">
                            <h2 className="text-lg font-semibold text-green-600">Additional Information</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
                                <TextField disabled label="Age" variant="outlined" fullWidth defaultValue="" />
                                <TextField disabled
                                    label="What do you do?"
                                    variant="outlined"
                                    fullWidth
                                    select
                                    defaultValue=""
                                >
                                    <MenuItem value="Student">Student</MenuItem>
                                    <MenuItem value="Employed">Employed</MenuItem>
                                </TextField>
                                <TextField disabled
                                    label="Workplace/School"
                                    variant="outlined"
                                    fullWidth
                                    defaultValue=""
                                />
                            </div>
                            <div className="flex flex-col sm:flex-row mt-4 space-y-2 sm:space-y-0 sm:space-x-4">
                                <FormControlLabel disabled
                                    control={<Checkbox />}
                                    label="Have you ever been in police custody?"
                                />
                                <FormControlLabel disabled
                                    control={<Checkbox />}
                                    label="Have you ever been convicted of a felony?"
                                />
                            </div>
                        </div>

                        {/* Emergency Contact */}
                        <div className="mt-6 bg-white p-4 rounded-lg shadow-sm">
                            <h2 className="text-lg font-semibold text-green-600">Emergency Contact Details/Next of Kin</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
                                <TextField disabled label="Full Name" variant="outlined" fullWidth defaultValue="" />
                                <TextField disabled label="Phone Number" variant="outlined" fullWidth defaultValue="" />
                                <TextField disabled label="Relationship" variant="outlined" fullWidth defaultValue="" />
                            </div>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1} className="py-4">
                        {/* Tenancy Details */}
                        {/* Room Details */}
                        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Account Name</label>
                                <input type="text" disabled value={selectedRoom?.fullName} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="John" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Tenant Room ID</label>
                                <input type="text" disabled value={selectedRoom?.tenantRoomId} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="Doe" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Account Status</label>
                                <input type="text" disabled value={selectedRoom?.active} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Property Name</label>
                                <input type="text" disabled value={selectedRoom?.room?.unit?.property?.name} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] capitalize placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Room Tag</label>
                                <input type="text" disabled value={selectedRoom?.room?.tag} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Unit Name</label>
                                <input type="text" disabled value={selectedRoom?.room?.unit?.name} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Check In Date</label>
                                <input type="text" disabled value={selectedRoom?.checkIn} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Check Out Date</label>
                                <input type="text" disabled value={selectedRoom?.checkOut} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                        </div>
                        {/* Invoice Details */}
                        <p className='mt-2'>Invoice Details</p>
                        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Invoice Title</label>
                                <input type="text" disabled value={tenantRoomDetails?.invoices[0]?.title} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="John" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Total Amount</label>
                                <input type="text" disabled value={tenantRoomDetails?.totalAmount} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Total Paid</label>
                                <input type="text" disabled value={tenantRoomDetails?.totalPaid} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Balance</label>
                                <input type="text" disabled value={tenantRoomDetails?.balance} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                        </div>
                        <div className="mt-10 w-full">
                            {/* <hr className='mt-2 mb-2' /> */}
                            <p className='text-center uppercase font-semibold'>Invoice Item(s)</p>
                            {/* Invoice Item Form */}
                            {isInvoiceEditable ?
                                <form onSubmit={formik2.handleSubmit}>
                                    <div className="pt-5 items-center w-100 flex flex-col md:flex-row gap-3">
                                        <TextField fullWidth id="standard-basic" label="Title" type='text' variant="outlined" name='title' value={formik2.values.title} onChange={formik2.handleChange} onBlur={formik2.handleBlur} error={formik2.touched.title && Boolean(formik2.errors.title)} helperText={formik2.touched.title && formik2.errors.title} />
                                        <TextField fullWidth id="standard-basic" label="Description" type='text' variant="outlined" name='description' value={formik2.values.description} onChange={formik2.handleChange} onBlur={formik2.handleBlur} error={formik2.touched.description && Boolean(formik2.errors.description)} helperText={formik2.touched.description && formik2.errors.description} />
                                        <TextField fullWidth id="standard-basic" label="Amount" type='text' variant="outlined" name="amount" value={formik2.values.amount} onChange={formik2.handleChange} onBlur={formik2.handleBlur} error={formik2.touched.amount && Boolean(formik2.errors.amount)} helperText={formik2.touched.amount && formik2.errors.amount} />
                                    </div>
                                    <div className="flex justify-end mt-3">
                                        <button type='submit' disabled={!(formik2.isValid && formik2.dirty)} className={`px-4 py-2 border ${formik2.isValid && formik2.dirty ? 'bg-green-700' : 'bg-gray-400'
                                            } text-white flex items-center gap-2`}><p className='font-light text-[16px]'>Add Item</p>
                                        </button>
                                    </div>
                                </form> : <div className="flex justify-end mt-3">
                                    <button onClick={() => setIsInvoiceEditable(true)} className={`px-4 py-2 border bg-green-700 text-white flex items-center gap-2`}><p className='font-light text-[16px]'>Edit/Add Invoice Item</p>
                                    </button>
                                </div>
                            }
                            {/* Display Invoice Item */}
                            <div className='!w-full overflow-x-auto'>
                                {
                                    Array.isArray(invoiceItems) && invoiceItems.length > 0 ? (
                                        <>
                                            {
                                                invoiceItems.map((item, i) => {
                                                    return (
                                                        <div className="pt-5 items-center w-full flex flex-col md:flex-row gap-3">
                                                            <TextField disabled={editableIndex !== i} fullWidth id="standard-basic" label="Title" type='text' className='w-full disabled:bg-gray-400' sx={{ width: '100%' }} variant="outlined" name='title' value={item.title} onChange={(e) => handleItemChange(e, i)} />
                                                            <TextField disabled={editableIndex !== i} fullWidth id="standard-basic" label="Description" type='text' className='w-full disabled:bg-gray-400' sx={{ width: '100%' }} variant="outlined" name='description' value={item.description} onChange={(e) => handleItemChange(e, i)} />
                                                            <TextField disabled={editableIndex !== i} fullWidth id="standard-basic" label="Amount" type='text' className='w-full disabled:bg-gray-400' sx={{ width: '100%' }} variant="outlined" name="amount" value={item.amount} onChange={(e) => handleItemChange(e, i)} />
                                                            {/* Conditional buttons */}
                                                            {editableIndex === i ? (
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => handleSave(i)}
                                                                >
                                                                    Save
                                                                </Button>
                                                            ) : (
                                                                <>
                                                                    {isInvoiceEditable && (
                                                                        <>
                                                                            <EditIcon
                                                                                className="cursor-pointer"
                                                                                title="Edit"
                                                                                onClick={() => setEditableIndex(i)}
                                                                            />
                                                                            <DeleteIcon
                                                                                className="cursor-pointer text-red-600"
                                                                                sx={{ fontSize: '18px' }}
                                                                                onClick={() => handleDeleteItem(i)}
                                                                            />
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </>
                                    ) : <div className="pb-5 flex items-center justify-center border-dashed border-green-500 border text-green-500 mt-10 flex-col hover:cursor-pointer bg-white text-[18px]">
                                        <span className='mt-4'>No item added</span>
                                    </div>
                                }
                            </div>
                            {isInvoiceEditable && <div className="flex justify-end mt-3">
                                {confirmLoading ? (
                                    <button disabled><p className='font-light text-[16px]'><SmallLoader /></p>
                                    </button>
                                ) : (
                                    <button onClick={handleUpdateInvoice} className='px-4 py-2 border hover:bg-austel-green bg-green-700 text-white flex items-center gap-2'><p className='font-light text-[16px]'>Update Invoice</p>
                                    </button>
                                )}
                            </div>}
                            <div className="flex justify-end mt-3">
                                <button onClick={() => setPaymentOpen(true)} className='px-6 py-2 border hover:bg-red-600 bg-red-700 text-white flex items-center gap-2'><p className='font-light text-[16px]'>Add Payment</p>
                                </button>
                            </div>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2} className="py-4">
                        {!loading && (Array.isArray(paymentHistory) && paymentHistory.length != 0) ?
                            <div className='overflow-x-auto my-table !w-[100%]'>
                                <table className='table-auto !w-full text-[#6C6C6C]'>
                                    <thead>
                                        <th>Type</th>
                                        <th>Ref</th>
                                        <th>Total Amount</th>
                                        <th>Amount Paid</th>
                                        <th>Balance</th>
                                        <th>Action</th>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(paymentHistory) && paymentHistory.map((payment, index) =>
                                            <tr className='mb-[30rem] mt-20 border-b-8 border-white'>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{payment.type}</td>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{payment.ref}</td>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{tenantRoomDetails?.invoices[0]?.totalAmount}</td>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{tenantRoomDetails?.invoices[0]?.totalPaid}</td>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{tenantRoomDetails?.balance}</td>
                                                <td className='flex gap-4 items-center'>
                                                    <span title='Delete payment' className='cursor-pointer'>
                                                        <DeleteIcon className='flex items-center cursor-pointer text-[#6C6C6C]' sx={{ fontSize: '18px' }} onClick={() => handleConfirmation(payment.id)} />
                                                    </span>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div> : <div className="flex flex-col gap-10 justify-center items-center mx-auto py-10 md:py-20">
                                <img src="/empty.svg" alt="" className='w-[200px]' />
                                No payments have been added to this tenant yet
                            </div>
                        }
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3}>
                        <div className="flex flex-col gap-10 justify-center items-center mx-auto py-10 md:py-20">
                            <img src="/no_document.svg" alt="" className='w-[500px]' />
                            No document is uploaded yet.
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={4} className="py-4">
                        {/* Profile Section */}
                        <div className="flex items-center space-x-4 relative">
                            <img
                                src={profileImage}
                                alt="Profile"
                                className="w-32 h-32 md:w-44 md:h-44 rounded-full border-2 border-gray-300"
                            />
                            <label htmlFor="file-upload" className="cursor-pointer absolute top-[8.5rem] left-[7.2rem]">
                                <div className="flex items-center justify-center w-10 h-10 bg-green-600 text-white rounded-full">
                                    📸
                                </div>
                            </label>
                            <input
                                id="file-upload"
                                type="file"
                                accept="image/*"
                                className="hidden"
                                onChange={handleFileChange}
                            />
                        </div>

                        {/* Form Fields */}
                        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>First Name</label>
                                <input type="text" disabled className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' value={tenantDetails?.user?.firstname} placeholder="John" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Last Name</label>
                                <input type="text" disabled className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' value={tenantDetails?.user?.lastname} placeholder="Doe" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Phone Number</label>
                                <input type="text" disabled className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' value={tenantDetails?.user?.phone} placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Email</label>
                                <input type="text" disabled className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' value={tenantDetails?.user?.email} placeholder="example@gmail.com" />
                            </div>
                        </div>

                        {/* Gender Selection */}
                        <div className="mt-4">
                            <FormControl>
                                <FormLabel>Gender</FormLabel>
                                <RadioGroup disabled row defaultValue="Female">
                                    <FormControlLabel value="Male" control={<Radio />} label="Male" />
                                    <FormControlLabel value="Female" control={<Radio />} label="Female" />
                                </RadioGroup>
                            </FormControl>
                        </div>

                        {/* Additional Info */}
                        <div className="mt-6 bg-white p-4 rounded-lg shadow-sm">
                            <h2 className="text-lg font-semibold text-green-600">Additional Information</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
                                <TextField disabled label="Age" variant="outlined" fullWidth defaultValue="" />
                                <TextField disabled
                                    label="What do you do?"
                                    variant="outlined"
                                    fullWidth
                                    select
                                    defaultValue=""
                                >
                                    <MenuItem value="Student">Student</MenuItem>
                                    <MenuItem value="Employed">Employed</MenuItem>
                                </TextField>
                                <TextField disabled
                                    label="Workplace/School"
                                    variant="outlined"
                                    fullWidth
                                    defaultValue=""
                                />
                            </div>
                            <div className="flex flex-col sm:flex-row mt-4 space-y-2 sm:space-y-0 sm:space-x-4">
                                <FormControlLabel disabled
                                    control={<Checkbox />}
                                    label="Have you ever been in police custody?"
                                />
                                <FormControlLabel disabled
                                    control={<Checkbox />}
                                    label="Have you ever been convicted of a felony?"
                                />
                            </div>
                        </div>

                        {/* Emergency Contact */}
                        <div className="mt-6 bg-white p-4 rounded-lg shadow-sm">
                            <h2 className="text-lg font-semibold text-green-600">Emergency Contact Details/Next of Kin</h2>
                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
                                <TextField disabled label="Full Name" variant="outlined" fullWidth defaultValue="" />
                                <TextField disabled label="Phone Number" variant="outlined" fullWidth defaultValue="" />
                                <TextField disabled label="Relationship" variant="outlined" fullWidth defaultValue="" />
                            </div>
                        </div>
                        {/* <button
                            onClick={handleFinalSubmit}
                            className="mt-6 px-8 py-4 bg-green-600 text-white rounded-md hover:bg-green-700"
                        >
                            Submit Profile
                        </button> */}
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={5} className="py-4">
                        <div className="flex justify-end mb-3">
                            <div className="flex-col gap-5">
                                <InputLabel id="demo-simple-select-label" className='!mb-2'>Tenent Room(s)</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name='roomId'
                                    defaultValue="Tenant Room(s)"
                                    className='!w-[150px] !h-[35px] !p-2 capitalize'
                                    value={tenantCurrentRoomId}
                                    onChange={handleRoomChange}
                                    MenuProps={{
                                        style: {
                                            maxHeight: 200,
                                        },
                                    }}
                                >
                                    {tenantRoomList}
                                </Select>
                            </div>
                        </div>
                        {/* Tenancy Details */}
                        {/* Room Details */}
                        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Account Name</label>
                                <input type="text" disabled value={selectedRoom?.fullName} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="John" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Tenant Room ID</label>
                                <input type="text" disabled value={selectedRoom?.tenantRoomId} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="Doe" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Account Status</label>
                                <input type="text" disabled value={selectedRoom?.active} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Property Name</label>
                                <input type="text" disabled value={selectedRoom?.room?.unit?.property?.name} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Room Tag</label>
                                <input type="text" disabled value={selectedRoom?.room?.tag} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Unit Name</label>
                                <input type="text" disabled value={selectedRoom?.room?.unit?.name} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Check In Date</label>
                                <input type="text" disabled value={selectedRoom?.checkIn} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Check Out Date</label>
                                <input type="text" disabled value={selectedRoom?.checkOut} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                        </div>
                        {/* Invoice Details */}
                        <p className='mt-2'>Invoice Details</p>
                        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Invoice Title</label>
                                <input type="text" disabled value={tenantRoomDetails?.invoices[0]?.title} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="John" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Total Amount</label>
                                <input type="text" disabled value={tenantRoomDetails?.totalAmount} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f] capitalize' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Total Paid</label>
                                <input type="text" disabled value={tenantRoomDetails?.totalPaid} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                            <div className='flex flex-col gap-2 text-[#6C6C6C] text-[10px] md:text-[12px] font-[300]'>
                                <label htmlFor="" className=''>Balance</label>
                                <input type="text" disabled value={tenantRoomDetails?.balance} className='text-[#000000DE] border-[0.75px] border-gray-300 focus:border-[#0FA958] px-2.5 py-3 outline-none focus:outline-none focus:border-2 rounded-[5px] text-[1rem] font-[400] placeholder:text-[#0000008f]' name='firstname' placeholder="" />
                            </div>
                        </div>
                        <div className="mt-6 w-full">
                            <p className='md:text-center'>Invoice Item</p>
                            {/* Invoice Item Form */}
                            {isInvoiceEditable ?
                                <form onSubmit={formik2.handleSubmit}>
                                    <div className="pt-5 items-center w-100 flex flex-col md:flex-row gap-3">
                                        <TextField fullWidth id="standard-basic" label="Title" type='text' variant="outlined" name='title' value={formik2.values.title} onChange={formik2.handleChange} onBlur={formik2.handleBlur} error={formik2.touched.title && Boolean(formik2.errors.title)} helperText={formik2.touched.title && formik2.errors.title} />
                                        <TextField fullWidth id="standard-basic" label="Description" type='text' variant="outlined" name='description' value={formik2.values.description} onChange={formik2.handleChange} onBlur={formik2.handleBlur} error={formik2.touched.description && Boolean(formik2.errors.description)} helperText={formik2.touched.description && formik2.errors.description} />
                                        <TextField fullWidth id="standard-basic" label="Amount" type='text' variant="outlined" name="amount" value={formik2.values.amount} onChange={formik2.handleChange} onBlur={formik2.handleBlur} error={formik2.touched.amount && Boolean(formik2.errors.amount)} helperText={formik2.touched.amount && formik2.errors.amount} />
                                    </div>
                                    <div className="flex justify-end mt-3">
                                        <button type='submit' disabled={!(formik2.isValid && formik2.dirty)} className={`px-4 py-2 border ${formik2.isValid && formik2.dirty ? 'bg-green-700' : 'bg-gray-400'
                                            } text-white flex items-center gap-2`}><p className='font-light text-[16px]'>Add Item</p>
                                        </button>
                                    </div>
                                </form> : <div className="flex justify-end mt-3">
                                    <button onClick={() => setIsInvoiceEditable(true)} className={`px-4 py-2 border bg-green-700 text-white flex items-center gap-2`}><p className='font-light text-[16px]'>Edit Item</p>
                                    </button>
                                </div>
                            }
                            {/* Display Invoice Item */}
                            <div className='!w-full overflow-x-auto'>
                                {
                                    Array.isArray(invoiceItems) && invoiceItems.length > 0 ? (
                                        <>
                                            {
                                                invoiceItems.map((item, i) => {
                                                    return (
                                                        <div className="pt-5 items-center w-full flex flex-col md:flex-row gap-3">
                                                            <TextField disabled={editableIndex !== i} fullWidth id="standard-basic" label="Title" type='text' className='w-full disabled:bg-gray-400' sx={{ width: '100%' }} variant="outlined" name='title' value={item.title} onChange={(e) => handleItemChange(e, i)} />
                                                            <TextField disabled={editableIndex !== i} fullWidth id="standard-basic" label="Description" type='text' className='w-full disabled:bg-gray-400' sx={{ width: '100%' }} variant="outlined" name='description' value={item.description} onChange={(e) => handleItemChange(e, i)} />
                                                            <TextField disabled={editableIndex !== i} fullWidth id="standard-basic" label="Amount" type='text' className='w-full disabled:bg-gray-400' sx={{ width: '100%' }} variant="outlined" name="amount" value={item.amount} onChange={(e) => handleItemChange(e, i)} />
                                                            {/* Conditional buttons */}
                                                            {editableIndex === i ? (
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => handleSave(i)}
                                                                >
                                                                    Save
                                                                </Button>
                                                            ) : (
                                                                <>
                                                                    {isInvoiceEditable && (
                                                                        <>
                                                                            <EditIcon
                                                                                className="cursor-pointer"
                                                                                title="Edit"
                                                                                onClick={() => setEditableIndex(i)}
                                                                            />
                                                                            <DeleteIcon
                                                                                className="cursor-pointer text-[#6C6C6C]"
                                                                                sx={{ fontSize: '18px' }}
                                                                                onClick={() => handleDeleteItem(i)}
                                                                            />
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </>
                                    ) : <div className="pb-5 flex items-center justify-center border-dashed border-green-500 border text-green-500 mt-10 flex-col hover:cursor-pointer bg-white text-[18px]">
                                        <span className='mt-4'>No item added</span>
                                    </div>
                                }
                            </div>
                            {isInvoiceEditable && <div className="flex justify-end mt-3">
                                {confirmLoading ? (
                                    <button disabled><p className='font-light text-[16px]'><SmallLoader /></p>
                                    </button>
                                ) : (
                                    <button onClick={handleUpdateInvoice} className='px-4 py-2 border hover:bg-austel-green bg-green-700 text-white flex items-center gap-2'><p className='font-light text-[16px]'>Update Invoice</p>
                                    </button>
                                )}
                            </div>}
                            <div className="flex justify-end mt-3">
                                <button onClick={() => setPaymentOpen(true)} className='px-6 py-2 border hover:bg-red-600 bg-red-700 text-white flex items-center gap-2'><p className='font-light text-[16px]'>Add Payment</p>
                                </button>
                            </div>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={6} className="py-4">
                        {!loading && (Array.isArray(paymentHistory) && paymentHistory.length != 0) ?
                            <div className='overflow-x-auto my-table !w-[100%]'>
                                <table className='table-auto !w-full text-[#6C6C6C]'>
                                    <thead>
                                        <th>Type</th>
                                        <th>Ref</th>
                                        <th>Total Amount</th>
                                        <th>Amount Paid</th>
                                        <th>Balance</th>
                                        <th>Action</th>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(paymentHistory) && paymentHistory.map((payment, index) =>
                                            <tr className='mb-[30rem] mt-20 border-b-8 border-white'>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{payment.type}</td>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{payment.ref}</td>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{tenantRoomDetails?.invoices[0]?.totalAmount}</td>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{tenantRoomDetails?.invoices[0]?.totalPaid}</td>
                                                <td className='capitalize text-[#0FA958] text-[16px]'>{tenantRoomDetails?.balance}</td>
                                                <td className='flex gap-4 items-center'>
                                                    <span title='Delete payment' className='cursor-pointer'>
                                                        <DeleteIcon className='flex items-center cursor-pointer text-[#6C6C6C]' sx={{ fontSize: '18px' }} onClick={() => handleConfirmation(payment.id)} />
                                                    </span>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div> : <div className="flex flex-col gap-10 justify-center items-center mx-auto py-10 md:py-20">
                                <img src="/no_payment.svg" alt="" className='w-[200px]' />
                                No payments have been added to this tenant yet
                            </div>
                        }
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={7}>
                        <div className="flex flex-col gap-10 justify-center items-center mx-auto py-10 md:py-20">
                            <img src="/no_document.svg" alt="" className='w-[500px]' />
                            No document is uploaded yet.
                        </div>
                    </CustomTabPanel>
                </Box>
                {/* Add payment modal */}
                <Dialog open={paymentOpen} onClose={handleClose} className='overflow-hidden'>
                    <form className='p-10' onSubmit={formik.handleSubmit}>
                        <h3 className='font-semibold'>Add Payment</h3>
                        <div className="pt-5 items-center w-100 flex flex-col md:flex-row gap-3">
                            <TextField fullWidth id="standard-basic" label="Amount" type='text' variant="outlined" name='amount' value={formik.values.amount} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.amount && Boolean(formik.errors.amount)} helpertext={formik.touched.amount && formik.errors.amount} />
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Type</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    className='capitalize'
                                    name='type'
                                    value={formik.values.type}
                                    onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.type && Boolean(formik.errors.type)} helpertext={formik.touched.type && formik.errors.type}
                                    MenuProps={{
                                        style: {
                                            maxHeight: 300,
                                        },
                                    }}
                                >
                                    {typeList}
                                </Select>
                            </FormControl>
                            <TextField fullWidth id="standard-basic" label="Ref (Optional)" type='text' variant="outlined" name="ref" value={formik.values.ref} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.ref && Boolean(formik.errors.ref)} helpertext={formik.touched.ref && formik.errors.ref} />
                        </div>
                        <div className="flex justify-end mt-3 cursor-pointer">
                            {confirmLoading ? (
                                <button disabled><p className='font-light text-[16px]'><SmallLoader /></p>
                                </button>
                            ) : (
                                <button type='submit' disabled={!(formik.isValid && formik.dirty)} className={`px-4 py-2 border ${formik.isValid && formik.dirty ? 'bg-green-700' : 'bg-gray-400'
                                    } text-white flex items-center gap-2`}><p className='font-light text-[16px]'>Add Payment</p>
                                </button>
                            )}
                        </div>
                    </form>
                </Dialog>
                {/* Snackbar */}
                <Snackbar open={showToaster} autoHideDuration={6000} onClose={handleToasterClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                    <Alert
                        onClose={handleToasterClose}
                        severity={toasterType}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
                {/* Confirmation Dialog */}
                <Dialog
                    open={confirmationOpen}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Delete payment?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this payment?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setConfirmationOpen(false)}>No</Button>
                        <Button sx={{ color: 'red' }} onClick={handleDeletePayment} autoFocus className='text-[#BD2424]'>
                            {!confirmLoading ? <span>Yes</span> : loader}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </React.Fragment>
    )
}

export default TenantDetails;
